import Home from './Home.data-manager-appsflyer.vue'

export default {
  Home
}